import { gql } from "urql"

export default gql`
  mutation ($sourceUserId: ID!, $matchUserId: ID!) {
    unmatchUser(studentId: $sourceUserId, tutorId: $matchUserId) {
      tutor {
        id
      }
    }
  }
`
